import React from 'react'
import { ThemeProvider } from 'styled-components'
import ReactDOM from 'react-dom/client'
import jsPDF from 'jspdf'

import { RecoveryCodesPDFTemplate } from '../RecoveryCodesPDFTemplate'

import { lightTheme as theme } from '@sketch/global-styles'
import { StyledButton } from './PrintToPDFButton.styles'

interface PrintToPDFButtonProps {
  codes: string[]
  children?: React.ReactNode
}

export const PrintToPDFButton = ({ codes }: PrintToPDFButtonProps) => {
  const handlePrintCodes = async () => {
    const container = document.createElement('div')
    const root = ReactDOM.createRoot(container)
    root.render(
      <ThemeProvider theme={theme}>
        <RecoveryCodesPDFTemplate recoveryCodes={codes} />
      </ThemeProvider>
    )

    const pdf = new jsPDF('p', 'pt', 'a4')
    pdf.html(container, {
      callback: function (pdf) {
        // Open PDF in a new tab
        const blob = pdf.output('blob')
        window.open(URL.createObjectURL(blob))
        root.unmount()
      },
    })
  }

  return (
    <StyledButton onClick={handlePrintCodes} size="40">
      Print Codes (PDF)
    </StyledButton>
  )
}
